import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { LoadingService } from "@coso/loading";
import { IS_SAAS } from "@coso/utility";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AutoStartMode, AutoStartModeName, GroupStorage, IConfigurationHolder } from "../../../models/auto-generated";
import { SettingsStore } from "../../../stores/settings.store";

@Component({
  standalone:false,
  templateUrl: "./general.component.html",
  styleUrls: ["./general.component.scss"]
})
export class GeneralComponent implements OnInit, OnDestroy, AfterViewInit {
  GroupStorage = GroupStorage;
  AutoStartMode = AutoStartMode;  

  private unsubscribe = new Subject<void>();
  @ViewChild(NgForm) public formRef: NgForm;
  errorMessage: string;
  modes: string[];
  settings$: Observable<IConfigurationHolder>;
  readonly$: Observable<boolean>;

  constructor(@Inject(IS_SAAS) public isSaaS: boolean, public loadingService: LoadingService, private settingsStore: SettingsStore) {
    this.modes =  !this.isSaaS
      ? Object.keys(AutoStartMode).filter((value) => isNaN(Number(value))) 
      : Object.keys(AutoStartMode).filter((value) => isNaN(Number(value)) && value != "Enabled");    
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
  }

  ngAfterViewInit(): void {
    // more info: https://angular.io/errors/NG0100
    setTimeout(() => {
      this.formRef.form.markAllAsTouched();
      this.formRef.form.statusChanges.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.settingsStore.updateValidity("general", this.formRef.valid);
      });
    }, 0);
  }

  ngOnInit(): void {
    this.settings$ = this.settingsStore.settings$;
    this.readonly$ = this.settingsStore.isReadOnly$;
  }

  getAutoStartModeName(mode: string) {
    return AutoStartModeName.get(AutoStartMode[mode]);
  }

  propagate(event: { type: string; payload: any }) {
    this.errorMessage = event.payload;
  }

  updateSettings(current: IConfigurationHolder) {
    this.settingsStore.updateSettings(current);
  }
}
